export type OriginalPostSnapshot = {
  content: string;
  images: string[];
  videoUrl: string | null;
  videoId: string | null;
};

const readString = (value: unknown) => (typeof value === 'string' && value.trim() ? value.trim() : null);

export const isPostEdited = (post: { edited_at?: unknown; editedAt?: unknown } | null | undefined) =>
  Boolean(post?.edited_at || post?.editedAt);

export const canEditWallPost = (post: any, userId?: string | null) => {
  if (!userId || !post) return false;
  const tags = Array.isArray(post.tags) ? post.tags.join(',') : String(post.tags ?? '');
  const link = String(post.external_link ?? post.externalLink ?? '');
  if (tags.toLowerCase().includes('instagram') || link.toLowerCase().includes('instagram.com')) return false;
  const owner = post.poster_id ?? post.author_id ?? null;
  return owner === userId;
};

export const readOriginalPost = (post: any): OriginalPostSnapshot | null => {
  const raw = post?.original_post ?? post?.originalPost;
  if (!raw || typeof raw !== 'object') return null;
  const images = Array.isArray(raw.images)
    ? raw.images.filter((image: unknown): image is string => typeof image === 'string' && image.trim().length > 0)
    : [];
  return {
    content: typeof raw.content === 'string' ? raw.content : '',
    images,
    videoUrl: readString(raw.video_url ?? raw.videoUrl ?? raw.video_link ?? raw.videoLink),
    videoId: readString(raw.video_id ?? raw.videoId),
  };
};
